// Live project demos, served as static folders from public/demos/<slug>/.
// Each is built in its own repo and copied here by `npm run demos:sync`.
// See docs/superpowers/specs/2026-09-27-live-demos-design.md.
export const demoRegistry = {
  pps_man: {
    path: '/demos/pps_man/',
    frame: 'browser',
    storagePrefix: 'demo:pps_man:',
    appKeyPrefixes: ['pss_'],
  },
};

export function getDemo(slug) {
  return slug && Object.prototype.hasOwnProperty.call(demoRegistry, slug) ? demoRegistry[slug] : null;
}

function removeMatching(storage, predicate) {
  const doomed = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key && predicate(key)) doomed.push(key);
  }
  doomed.forEach((key) => storage.removeItem(key));
}

// Demos run in a same-origin iframe, so their storage is the tab's. Reset
// clears the overlay's own sessionStorage prefix plus, from both storages,
// any keys the demo app itself wrote under its registered appKeyPrefixes.
export function clearDemoState(demo, session = window.sessionStorage, local = window.localStorage) {
  try {
    removeMatching(session, (key) => key.startsWith(demo.storagePrefix));
    const appPrefixes = demo.appKeyPrefixes || [];
    if (appPrefixes.length > 0) {
      const isAppKey = (key) => appPrefixes.some((prefix) => key.startsWith(prefix));
      removeMatching(session, isAppKey);
      removeMatching(local, isAppKey);
    }
  } catch (e) {
    // Storage blocked: the demo is running from memory and reload resets it.
  }
}
